export const sourceWebsiteConstants = {

    ACTION_SAVE: 'SOURCE_WEBSITE_ACTION_SAVE',
    ACTION_UPDATE_PASSWORD: 'SOURCE_WEBSITE_ACTION_UPDATE_PASSWORD',

    KICK_REQUEST: 'SOURCE_WEBSITE_KICK_REQUEST',
    KICK_SUCCESS: 'SOURCE_WEBSITE_KICK_SUCCESS',
    KICK_FAILURE: 'SOURCE_WEBSITE_KICK_FAILURE',

    GETALL_REQUEST: 'SOURCE_WEBSITE_GETALL_REQUEST',
    GETALL_SUCCESS: 'SOURCE_WEBSITE_GETALL_SUCCESS',
    GETALL_FAILURE: 'SOURCE_WEBSITE_GETALL_FAILURE',

    GETONE_REQUEST: 'SOURCE_WEBSITE_GETONE_REQUEST',
    GETONE_SUCCESS: 'SOURCE_WEBSITE_GETONE_SUCCESS',
    GETONE_FAILURE: 'SOURCE_WEBSITE_GETONE_FAILURE',

    DELETE_REQUEST: 'SOURCE_WEBSITE_DELETE_REQUEST',
    DELETE_SUCCESS: 'SOURCE_WEBSITE_DELETE_SUCCESS',
    DELETE_FAILURE: 'SOURCE_WEBSITE_DELETE_FAILURE',


};
